// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';
import classNames from 'classnames';

import {MenuContext} from '../menu_context';

import './menu_item.scss';

const hoverDisabledStyle = {
    pointerEvents: 'none',
};

const defaultStyle = {};

export default function menuItem(Component: React.ComponentType<any>) {
    type Props = {
        show: boolean;
        id?: string;
        icon?: React.ReactNode;
        text?: React.ReactNode;
        hoverDisabled?: boolean;
        dataQa?: string;
    };
    class MenuItem extends React.PureComponent<Props & React.ComponentProps<typeof Component>> {
        public static defaultProps = {
            show: true,
        };

        public static displayName?: string;

        public static contextType = MenuContext;

        hideSubmenuItem = () => this.context.onCloseSubMenuItem();

        public render() {
            const {id, show, icon, text, ...props} = this.props;
            if (!show) {
                return null;
            }

            let textProp: React.ReactNode = text;
            if (icon) {
                textProp = (
                    <>
                        <span className='icon'>{icon}</span>
                        {text}
                    </>
                );
            }

            return (
                <li
                    className={classNames('MenuItem', {
                        'MenuItem--with-icon': icon,
                    })}
                    style={this.props.hoverDisabled ? hoverDisabledStyle : defaultStyle}
                    role='menuitem'
                    id={id}
                    data-qa={this.props.dataQa}
                    onMouseEnter={this.hideSubmenuItem}
                >
                    <Component
                        text={textProp}
                        ariaLabel={text}
                        {...props}
                    />
                </li>
            );
        }
    }
    return MenuItem;
}
